import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Plus, ArrowClockwise } from 'react-bootstrap-icons';
import { Fragment } from 'react';
import { Carousel, Modal, Spinner, Button, Col, Row, Table, Image, Tabs, Tab, Form }  from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Typeahead } from 'react-bootstrap-typeahead'; 

import 'react-bootstrap-typeahead/css/Typeahead.css';


import { REACT_APP_DJANGO_ADMIN_URL, REACT_APP_WEBSITE_URL } from 'utils/settings'

import api from 'utils/api';


const EventsIncoming = () => {
  const location = useLocation();

  const hasDiff = event => (
    event.diff && Object.keys(event.diff).some(key => key !== 'venue')
  );

  const [loading, setLoading] = React.useState(false);

  const [events, setEvents] = React.useState([]);
  const [eventTypes, setEventTypes] = React.useState([]);
  const [venues, setVenues] = React.useState([]);
  const [eventsCount, setEventsCount] = React.useState(0);
  const [allEventsSwitch, setAllEventsSwitch] = React.useState(() => !new URLSearchParams(location.search).has('page'));

  const [renewUpdates, setRenewUpdates] = React.useState([]);
  const [publishUpdates, setPublishUpdates] = React.useState([]);
  const [similarEvents, setSimilarEvents] = React.useState([]);
  const [similarLoading, setSimilarLoading] = React.useState([]);
  const [instagramDisappearedChecks, setInstagramDisappearedChecks] = React.useState({});

  const [confirmDialogShow, setConfirmDialogShow] = React.useState(false);
  const [renewPK, setRenewPK] = React.useState(null);

  const slugInputRefs = useRef(new Map());
  const locationInputRefs = useRef(new Map());

  const fetchEvents = React.useCallback(() => {
    var url = '/event/incoming/';
    if(!allEventsSwitch)
        url += '?page=1';

    api
      .get(url)
      .then(res => {
        const { data } = res;
        if (data) {
          console.log(data);
          if(allEventsSwitch) {
            setEvents(data);
            setEventsCount(data.length);
          } else {
            setEvents(data.results);
            setEventsCount(data.count);
          }
          setRenewUpdates([]);
          setPublishUpdates([]);
          setSimilarEvents([]);
          setInstagramDisappearedChecks({});
        }
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setEvents, setLoading, setEventsCount, setRenewUpdates, setPublishUpdates, setSimilarEvents, setInstagramDisappearedChecks, allEventsSwitch]);

  const fetchEventTypes = React.useCallback(() => {
    var url = '/event/types/';

    api
      .get(url)
      .then(res => {
        const { data } = res;
        if (data) {
          console.log(data);
          setEventTypes(data);
        }
      })
  }, [setEventTypes]);

  const fetchVenues = React.useCallback(() => {
    api
      .get('/event/venues/')
      .then(res => {
        const { data } = res;
        if(data)
          setVenues(data);
      })
      .catch(() => {
        toast.error('Failed to load venues');
      });
  }, [setVenues]);

  const refresh = React.useCallback(() => {
    setLoading(true);
    fetchEvents();
  }, [fetchEvents, setLoading]);

  React.useEffect(() => {
    fetchEventTypes();
    fetchVenues();
  }, [fetchEventTypes, fetchVenues]);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  React.useEffect(() => {
    setAllEventsSwitch(!new URLSearchParams(location.search).has('page'));
  }, [location.search]);

  const hideEvent = React.useCallback((pk) => {
    const newEvents = [...events];
    events.forEach((event, index) => {
      if(event['pk'] === pk) {
        newEvents.splice(index, 1);
      }   
    })
    setEvents(newEvents);
    setEventsCount(eventsCount-1);
  }, [events, eventsCount, setEvents, setEventsCount]);

  const checkUrlSlug = React.useCallback((url_slug) => {
    api
      .post('/event/checkurlslug/', {'url_slug': url_slug})
      .then(res => {
        const { data } = res;
        console.log(data);
        if(data.url_slug_exists)
          toast.info(
            <div>
              <span>Url slug {url_slug} exists!</span>
            </div>
          )
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
      });
  }, []);

  const onEventNotEvent = React.useCallback((pk) => {
    setLoading(true);

    api
      .post('/event/' + pk.toString() + '/notevent/')
      .then(res => {
        toast.info(
          <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + pk.toString() + '/change/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Event discarded as not event. </span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setLoading, hideEvent]);

  const onEventNotPublish = React.useCallback((pk) => {
    setLoading(true);

    api
      .post('/event/' + pk.toString() + '/notpublish/')
      .then(res => {
        toast.info(
          <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + pk.toString() + '/change/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Event discarded as not to publish. </span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setLoading, hideEvent]);

  const onEventPublish = React.useCallback((pk) => {
    setLoading(true);

    let params = {};

    if(pk in publishUpdates)
      params = publishUpdates[pk]

    if('dates' in params)
      for(var date in params['dates']) {
        if(params['dates'][date].start_date === '')
          params['dates'][date].start_date = null;
        if(params['dates'][date].end_date === '')
          params['dates'][date].end_date = null;
      }

    api
      .post('/event/' + pk.toString() + '/publish/', params)
      .then(res => {
        const { data } = res;
        let published_event = data;
        toast.info(
          <a href={REACT_APP_WEBSITE_URL + 'event/' + published_event.url_slug + '/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Published Event</span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [publishUpdates, setLoading, hideEvent]);

  const onEventHide = React.useCallback((pk) => {
    setLoading(true);

    api
      .post('/event/' + pk.toString() + '/hide-event/')
      .then(res => {
        toast.info(
          <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + pk.toString() + '/change/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Event hided</span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setLoading, hideEvent]);

  const onEventHideLink = React.useCallback((pk) => {
    setLoading(true);

    api
      .post('/event/' + pk.toString() + '/hide-link/')
      .then(res => {
        toast.info(
          <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + pk.toString() + '/change/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Event link hided</span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setLoading, hideEvent]);

  const onEventOutdated = React.useCallback((pk) => {
    setLoading(true);

    api
      .post('/event/' + pk.toString() + '/outdated/')
      .then(res => {
        toast.info(
          <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + pk.toString() + '/change/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Event outdated </span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [setLoading, hideEvent]);

  const onInstagramDisappearedCheck = React.useCallback((pk) => {
    setInstagramDisappearedChecks(currentChecks => ({
      ...currentChecks,
      [pk]: 'checking',
    }));

    api
      .post('/event/' + pk.toString() + '/check-instagram-disappeared/')
      .then(res => {
        const { data } = res;

        setInstagramDisappearedChecks(currentChecks => ({
          ...currentChecks,
          [pk]: data.is_disappeared ? 'disappeared' : 'not_disappeared',
        }));
      }).catch(err => {
        setInstagramDisappearedChecks(currentChecks => ({
          ...currentChecks,
          [pk]: 'failed',
        }));
      });
  }, [setInstagramDisappearedChecks]);

  const getInstagramDisappearedCheckButton = React.useCallback((pk) => {
    const status = instagramDisappearedChecks[pk];

    if(status === 'checking') {
      return {
        text: 'Checking...',
        variant: 'primary',
        disabled: true,
      };
    }

    if(status === 'not_disappeared') {
      return {
        text: 'Not disappeared',
        variant: 'success',
        disabled: false,
      };
    }

    if(status === 'disappeared') {
      return {
        text: 'Disappeared',
        variant: 'danger',
        disabled: false,
      };
    }

    if(status === 'failed') {
      return {
        text: 'Check failed',
        variant: 'warning',
        disabled: false,
      };
    }

    return {
      text: 'Check if disappeared',
      variant: 'secondary',
      disabled: false,
    };
  }, [instagramDisappearedChecks]);


  const handleConfirmDialogClose = React.useCallback(() => {
    setConfirmDialogShow(false);
  }, []);

  const handleConfirmDialogShow = React.useCallback(() => {
    setConfirmDialogShow(true);
  }, []);

  const eventRenew = React.useCallback((pk) => {
    handleConfirmDialogClose();
    setLoading(true);

    let params = {};

    if(pk in renewUpdates)
        params = renewUpdates[pk];

    api
      .post('/event/' + pk.toString() + '/renew/', params)
      .then(res => {
        const { data } = res;
        let renewed_event = data;

        toast.info(
          <a href={REACT_APP_WEBSITE_URL + 'event/' + renewed_event.url_slug + '/'} target='_blank' rel='noreferrer'>
            <div>
              <span>Success! </span>
              <span>Renewed Event</span>
            </div>
          </a>
        )
        hideEvent(pk);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        setLoading(false);
      });
  }, [renewUpdates, setLoading, handleConfirmDialogClose, hideEvent]);

  const onEventRenew = React.useCallback((pk) => {
    setRenewPK(pk);

    let event = null;
    for(let e in events) {
      if(events[e].pk === pk) {
        event = events[e];
      }
    }

    // TODO: refactor
    const diff = Object.keys(event.diff || {}).filter(
      key => key !== 'venue'
    );

    let params = [];
    if(pk in renewUpdates)
      params = renewUpdates[pk];

    for(let d in diff) {
      if(!(diff[d] in params)) {
        handleConfirmDialogShow();
        return;
      }
    }
    eventRenew(pk);

  }, [events, renewUpdates, eventRenew, handleConfirmDialogShow]);

  const onPropertyRenewApply = React.useCallback((pk, prop, value) => {
    var newRenewUpdates = [...renewUpdates];

    if(!(pk in newRenewUpdates))
      newRenewUpdates[pk] = {};
    newRenewUpdates[pk][prop] = value;

    setRenewUpdates(newRenewUpdates);
  }, [renewUpdates]);

  const onSourceEventShowInPostApply = React.useCallback((pk, sourceEventPk, checked) => {
    var newRenewUpdates = [...renewUpdates];

    if(!(pk in newRenewUpdates))
      newRenewUpdates[pk] = {};
    if(!('hide_source_event_pks' in newRenewUpdates[pk]))
      newRenewUpdates[pk]['hide_source_event_pks'] = [];

    if(checked) {
      newRenewUpdates[pk]['hide_source_event_pks'] = newRenewUpdates[pk]['hide_source_event_pks'].filter(
        eventPk => eventPk !== sourceEventPk
      );
    } else if(!newRenewUpdates[pk]['hide_source_event_pks'].includes(sourceEventPk)) {
      newRenewUpdates[pk]['hide_source_event_pks'].push(sourceEventPk);
    }

    setRenewUpdates(newRenewUpdates);
  }, [renewUpdates]);

  const onDateAdd = React.useCallback((pk) => {
    var newPublishUpdates = [...publishUpdates];

    if(!(pk in newPublishUpdates)) {
      newPublishUpdates[pk] = {}
    }
    if(!('dates' in newPublishUpdates[pk])) {
      newPublishUpdates[pk]['dates'] = [];
    }
    var dates = newPublishUpdates[pk]['dates'];

    dates.push({
      'start_date': '',
      'end_date': '',
      'is_start_time_present': true,
      'is_end_time_present': false,
    })

    newPublishUpdates[pk]['dates'] = dates;
    setPublishUpdates(newPublishUpdates);
  }, [publishUpdates]);


  const onPropertyDatePublishApply = React.useCallback((pk, index, prop, value) => {
    var newPublishUpdates = [...publishUpdates];
    var dates = newPublishUpdates[pk]['dates'];

    dates[index][prop] = value;

    newPublishUpdates[pk]['dates'] = dates;
    setPublishUpdates(newPublishUpdates);
  }, [publishUpdates]);

  const onPropertyPublishApply = React.useCallback((pk, prop, value) => {
    console.log(prop);
    console.log(value);

    if(prop === 'url_slug' && value !== '') {
      checkUrlSlug(value);
    }
    var newPublishUpdates = [...publishUpdates];

    if(!(pk in newPublishUpdates))
      newPublishUpdates[pk] = {};
    newPublishUpdates[pk][prop] = value;

    setPublishUpdates(newPublishUpdates);
  }, [publishUpdates, checkUrlSlug]);

  const onVenueApply = React.useCallback((event, selected) => {
    const venue = selected[0]?.value || null;

    if(event.published_events_list.length === 0) {
      onPropertyPublishApply(event.pk, 'venue', venue);
    } else {
      onPropertyRenewApply(event.pk, 'venue', venue);
    }
  }, [onPropertyPublishApply, onPropertyRenewApply]);

  const getSelectedVenue = React.useCallback((event) => {
    const updates = event.published_events_list.length === 0
      ? publishUpdates
      : renewUpdates;
    const eventUpdates = updates?.[event.pk] || {};

    let venue = event.published_events_list.length === 0
      ? event.venue
      : event.published_event?.venue;

    if(Object.prototype.hasOwnProperty.call(eventUpdates, 'venue'))
      venue = eventUpdates.venue;

    return venues.filter(item => item.value === venue);
  }, [venues, publishUpdates, renewUpdates]);

  const handleConfirmDialogProceed = React.useCallback(() => {
    setConfirmDialogShow(true);
    eventRenew(renewPK);
  }, [eventRenew, renewPK]);

  const onSlugCopyPaste = React.useCallback(async (slug) => {
    if (!slug) {
      toast.error('Nothing to copy');
      return;
    }

    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        await navigator.clipboard.writeText(slug);
        toast.info('Copied!');
        return;
      } catch (err) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
    }

    toast.error('Copy failed');
  }, []);

  const applyDefaultLocation = React.useCallback((pk, defaultLocationText) => {
    const inputRef = locationInputRefs.current.get(pk);

    if(inputRef)
      inputRef.value = defaultLocationText;

    onPropertyPublishApply(pk, 'location_text', defaultLocationText);
  }, [locationInputRefs, onPropertyPublishApply]);

  const transliterate = React.useCallback((pk) => {
    const inputRef = slugInputRefs.current.get(pk);
    const text = inputRef.value;

    api
      .post('/utils/transliterate/', {'text': text})
      .then(res => {
        const { data } = res;
        console.log(data);
        const new_next = data['transliterated_text'];
        inputRef.value = new_next;
        onPropertyPublishApply(pk, 'url_slug', new_next);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
      });
  }, [slugInputRefs, onPropertyPublishApply]);

  const onSimilarEventsFetch = React.useCallback((pk) => {
    var newSimilarLoading = [...similarLoading];
    newSimilarLoading[pk] = true;
    setSimilarLoading(newSimilarLoading);

    api
      .get('/event/' + pk.toString() + '/similar/')
      .then(res => {
        const { data } = res;
        var newSimilarEvents = [...similarEvents];
        newSimilarEvents[pk] = data;
        setSimilarEvents(newSimilarEvents);
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      }).finally(() => {
        var newSimilarLoading = [...similarLoading];
        newSimilarLoading[pk] = false;
        setSimilarLoading(newSimilarLoading);
      });
  }, [similarEvents, similarLoading, setSimilarEvents, setSimilarLoading]);

  const onSimilarEventAdd = React.useCallback((pk, similarEvent) => {
    api
      .post('/event/' + pk.toString() + '/add-published-event/', {'published_event': similarEvent.pk})
      .then(res => {
        const url = REACT_APP_WEBSITE_URL + 'event/' + similarEvent.url_slug + '/';

        hideEvent(pk);
        toast.info(
          <a href={url} target='_blank' rel='noreferrer'>
            <div>
              <span>Добавлено. </span>
              <span>Открыть событие</span>
            </div>
          </a>
        );
      }).catch(err => {
        toast.error('Error, stop all work and report to admin!');
      });
  }, [hideEvent]);

  const onSimilarEventReplaceSlug = React.useCallback((pk, similarEvent) => {
    const inputRef = slugInputRefs.current.get(pk);

    if(inputRef)
      inputRef.value = similarEvent.url_slug;

    onPropertyPublishApply(pk, 'url_slug', similarEvent.url_slug);
  }, [slugInputRefs, onPropertyPublishApply]);

  const renderSimilarEventsRows = React.useCallback((event, title, rows) => (
    <>
      <tr>
        <td
          style={{backgroundColor: "LightSlateGray", color: "white"}}
          className='align-middle'
          colSpan="5"
        >
          <span>{title}</span>
        </td>
      </tr>
      {rows.length === 0 &&
      <tr>
        <td colSpan="5">Нет похожих событий</td>
      </tr>
      }
      {rows.map(similarEvent => (
      <tr key={similarEvent.pk} className={similarEvent.is_disappeared ? 'table-danger' : undefined}>
        <td>
          <a href={REACT_APP_WEBSITE_URL + 'event/' + similarEvent.url_slug + '/'} target='_blank' rel='noreferrer'>
            {similarEvent.url_slug}
          </a>
        </td>
        <td>{similarEvent.title}</td>
        <td>{similarEvent.date_display}</td>
        <td>{similarEvent.distance}</td>
        <td>
          <Button onClick={() => onSimilarEventAdd(event.pk, similarEvent)} className='me-2' size="sm">Добавить</Button>
          <Button onClick={() => onSimilarEventReplaceSlug(event.pk, similarEvent)} size="sm">Заместить</Button>
        </td>
      </tr>
      ))}
    </>
  ), [onSimilarEventAdd, onSimilarEventReplaceSlug]);

  const renderSourceEventsRows = React.useCallback((event, title, rows, showCheckboxHeader) => (
    <>
      {rows.length > 0 &&
      <>
        <tr>
          <td
            style={{backgroundColor: "LightSlateGray", color: "white"}}
            className='align-middle'
          >
            <span>{title}</span>
          </td>
          <td
            style={{backgroundColor: "LightSlateGray", color: "white"}}
            className='align-middle'
          >
          </td>
          <td
            style={{backgroundColor: "LightSlateGray", color: "white"}}
            className='align-middle'
          >
            <span>{showCheckboxHeader ? 'Показывать на странице' : ''}</span>
          </td>
        </tr>
        {rows.map(sourceEvent => (
        <tr key={sourceEvent.pk}>
          <td>
            <a href={sourceEvent.source_page_url} target='_blank' rel='noreferrer'>
              {sourceEvent.slug}
            </a>
          </td>
          <td>
            <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + sourceEvent.pk + '/change/'} target='_blank' rel='noreferrer'>
              #B {sourceEvent.pk}
            </a>
          </td>
          <td>
            <Form.Check
              type='checkbox'
              checked={!renewUpdates?.[event.pk]?.hide_source_event_pks?.includes(sourceEvent.pk)}
              onChange={e => onSourceEventShowInPostApply(event.pk, sourceEvent.pk, e.target.checked)}
            />
          </td>
        </tr>
        ))}
      </>
      }
    </>
  ), [renewUpdates, onSourceEventShowInPostApply]);

  const getSourceEvents = React.useCallback((event, isWeb) => (
    event.published_event?.source_events_list?.filter(sourceEvent => (sourceEvent.source_type === 'web_site') === isWeb) || []
  ), []);

  return (
    <>
      <Row>
        <Col>
          <Form.Check
            type='switch'
            label='All events'
            checked={allEventsSwitch}
            onChange={e => setAllEventsSwitch(e.target.checked)}
          />
        </Col>
        <Col className='text-center col-6'>
          <h5 className='my-0'>ВХОДЯЩИЕ СОБЫТИЯ ({eventsCount})</h5>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className='pt-1 ps-2' style={{'cursor': 'pointer'}} onClick={refresh}><ArrowClockwise size={32} /></div>
        </Col>
      </Row>
      {events && events.map(event => (
        <Fragment key={event.pk}>
        <Row>
          <Col>
            <hr className='mt-1 mb-2 pb-0' />
          </Col>
        </Row>
        <Row className='pb-1'>
          <Col className='col-lg-7'>
            {event.is_disappeared && event.published_events_list.length === 0 &&
              <>
                <Button onClick={() => onEventHide(event.pk)} className='me-2' size="sm">Исчез</Button>
              </>
            }
            {event.is_disappeared && event.published_events_list.length !== 0 &&
              <>
                <Button onClick={() => onEventHide(event.pk)} className='me-2' size="sm">Исчез, спрятать пост</Button>
                <Button onClick={() => onEventHideLink(event.pk)} className='me-2' size="sm">Исчез, спрятать ссылку</Button>
              </>
            }
            {event.is_instagram && event.is_disappeared &&
              <Button
                onClick={() => onInstagramDisappearedCheck(event.pk)}
                className='me-2'
                size="sm"
                variant={getInstagramDisappearedCheckButton(event.pk).variant}
                disabled={getInstagramDisappearedCheckButton(event.pk).disabled}
              >{getInstagramDisappearedCheckButton(event.pk).text}</Button>
            }
            {event.published_events_list.length === 0 &&
              <>
                <Button
                  onClick={() => onEventNotEvent(event.pk)}
                  className='me-2'
                  size="sm"
                  variant={event.is_event_ai === false ? 'danger' : event.is_event_ai === true ? 'success' : 'primary'}
                >Не событие</Button>
                <Button onClick={() => onEventPublish(event.pk)} className='me-2' size="sm">Опубликовать</Button>
                <Button onClick={() => onEventNotPublish(event.pk)} className='me-2' size="sm">Не надо</Button>
                <Button onClick={() => onEventOutdated(event.pk)} className='me-2' size="sm">Прошло</Button>
                <Button onClick={() => onSimilarEventsFetch(event.pk)} className='me-2' size="sm" disabled={similarLoading?.[event.pk] === true}>Похожие</Button>
              </>
            }
            {event.published_events_list.length !== 0 &&
              <>
                <Button onClick={() => onEventRenew(event.pk)} className='me-2' size="sm">Обновить</Button>
              </>
            }
          </Col>
          <Col className='col-lg-3'>
            <span>{event.source_display}</span>
            {event.source_type === 'web_site' &&
              <span className='badge text-bg-primary mx-2'>W</span>  
            }
          </Col>
          <Col className='col-lg-2'>
            <span className='badge text-bg-primary' style={{ cursor: 'pointer' }} onClick={() => onSlugCopyPaste(event.slug)}>{event.slug}</span>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr className='mt-1 mb-2 pb-0' />
          </Col>
        </Row>
        <Row className='pt-1 pb-1'>
          <Col lg="4" className='pb-3'>
            {event.images.length > 1 &&
              <Carousel
                indicators={true}
                interval={null}
                onSelect={(index) => onPropertyPublishApply(event.pk, 'image_index', index)}
              >
                {event.images.map(image => (    
                  <Carousel.Item key={image.pk}>
                    <Image src={image.url} style={{width: '100%', height: 'auto'}}/>
                  </Carousel.Item>
                ))}
              </Carousel>
             }
            {event.images.length === 1 &&
              <a href={event.images[0].url} target="_blank" rel="noreferrer">
                <Image src={event.images[0].url} style={{width: '100%', height: 'auto'}}/>
              </a>
            }
          </Col>
          <Col lg="8">
            <Tabs
              defaultActiveKey='html'
              className='mb-3'
            >
              <Tab eventKey='html' title='HTML'>
                <div dangerouslySetInnerHTML={{__html: event.description_display }} />
              </Tab>            
              <Tab eventKey='raw' title='Raw' mountOnEnter>
                {event.description}
              </Tab>            
              <Tab eventKey='edit' title='Edit'>
                <Form.Control
                  as='textarea'
                  defaultValue={event.description}
                  rows={10}
                  onChange={e => onPropertyPublishApply(event.pk, 'description', e.target.value)}
                />
              </Tab>            
            </Tabs>
          </Col>
        </Row>
        <Row className='pt-1 pb-1'>
          <Col>
            <Table bordered striped>
              <tbody>
                {hasDiff(event) &&
                <tr>
                  <td
                    style={{backgroundColor: "LightSlateGray", color: "white"}}
                    className='align-middle'
                    colSpan="2"
                  >
                    <span>Различия</span>
                  </td>
                </tr>
                } 
                {hasDiff(event) && Object.keys(event.diff).filter(
                  key => key !== 'venue'
                ).map((key, index) => (
                <Fragment key={key}>
                <tr>
                  <td className='fw-bold'>{key}</td>
                  <td>
                    <Form.Check
                      checked={renewUpdates?.[event.pk]?.[key] === true ? true : false }
                      type='switch'
                      label='Применить'
                      onChange={e => onPropertyRenewApply(event.pk, key, e.target.checked)}
                    />
                  </td>
                </tr>
                {key !== 'images' &&
                <tr>
                  <td>
                    {key === 'dates' ? 
                      <pre>{String(event.diff[key]['previous'])}</pre> : 
                      <span>{String(event.diff[key]['previous'])}</span>
                    }
                  </td>
                  <td>
                    {key === 'dates' ? 
                      <pre>{String(event.diff[key]['current'])}</pre> :
                      <span>{String(event.diff[key]['current'])}</span>
                    }
                  </td>
                </tr>
                }
                {key === 'images' &&
                <>
                <tr>
                  <td><Image src={event.diff['images']['image']['previous']} style={{width: '100%', height: 'auto'}}/></td>
                  <td><Image src={event.diff['images']['image']['current']} style={{width: '100%', height: 'auto'}}/></td>
                </tr>
                {event.diff['images']['image_md5'] &&
                <tr>
                  <td>{event.diff['images']['image_md5']['previous']}</td>
                  <td>{event.diff['images']['image_md5']['current']}</td>
                </tr>
                }
                {!event.diff['images']['image_md5'] && 
                <tr>
                  <td colSpan='2'>Одинаковый MD5</td>
                </tr>
                }
                </>
                }
                </Fragment>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        {event.published_events_list.length !== 0 && hasDiff(event) &&
        <Row className='pt-1 pb-1'>
          <Col>
            <Table bordered striped size="sm">
              <tbody>
                {renderSourceEventsRows(
                  event,
                  'Web события',
                  getSourceEvents(event, true),
                  true,
                )}
                {renderSourceEventsRows(event, 'Instagram события', getSourceEvents(event, false), false)}
              </tbody>
            </Table>
          </Col>
        </Row>
        }
        {similarEvents?.[event.pk] &&
        <Row className='pt-1 pb-1'>
          <Col>
            <Table bordered striped size="sm">
              <thead>
                <tr>
                  <th>URL Слаг</th>
                  <th>Заголовок</th>
                  <th>Даты</th>
                  <th>Distance</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {renderSimilarEventsRows(event, 'Похожие будущие', similarEvents[event.pk].future)}
                {renderSimilarEventsRows(event, 'Похожие прошедшие', similarEvents[event.pk].past)}
              </tbody>
            </Table>
          </Col>
        </Row>
        }
        <Row className='pt-1 pb-1'>
          <Col>
            <Table bordered striped>
              <tbody>
                {event.is_disappeared &&
                <tr>
                  <td className='fw-bold'>ИСЧЕЗ !!!</td>
                  <td></td>
                </tr>
                }
                <tr>
                  <td className='fw-bold'>Источник</td>
                  <td>{event.source_display}</td>
                </tr>
                <tr>
                  <td className='fw-bold'>Ссылка</td>
                  <td>
                    <a href={event.source_page_url} rel='nofollow noopener noreferrer' target='_blank'>{event.source_page_url}</a>
                  </td>
                </tr>
                {event.appeared_at_display &&
                <tr>
                  <td className='fw-bold'>Опубликовано</td>
                  <td>{event.appeared_at_display}</td>
                </tr>
                }
                {event.first_seen_at_display &&
                <tr>
                  <td className='fw-bold'>First seen</td>
                  <td>{event.first_seen_at_display}</td>
                </tr>
                }
                <tr>
                  <td className='fw-bold'>Заголовок</td>
                  <td>
                    <Form.Control
                      type='text'
                      defaultValue={event.title}
                      onChange={e => onPropertyPublishApply(event.pk, 'title', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Локация</td>
                  <td className='d-flex align-items-center'>
                    <Form.Control
                      type='text'
                      defaultValue={event.location_text}
                      onChange={e => onPropertyPublishApply(event.pk, 'location_text', e.target.value)}
                      className='me-2'
                      ref={(el) => locationInputRefs.current.set(event.pk, el)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Площадка</td>
                  <td>
                    <Typeahead
                      id={`typeahead-event-venue-${event.pk}`}
                      labelKey='label'
                      options={venues}
                      selected={getSelectedVenue(event)}
                      onChange={selected => onVenueApply(event, selected)}
                      placeholder='Оставить текстовую локацию'
                      clearButton
                    />
                  </td>
                </tr>
                {event.default_location_text &&
                <tr>
                  <td className='fw-bold'>Локация по умолчанию</td>
                  <td className='d-flex align-items-center'>
                    <Form.Control
                      type='text'
                      value={event.default_location_text}
                      readOnly
                      className='me-2'
                    />
                    <Button
                      onClick={() => applyDefaultLocation(event.pk, event.default_location_text)}
                      className='me-2'
                    >Use</Button>
                  </td>
                </tr>
                }
                <tr>
                  <td className='fw-bold'>Тип события</td>
                  <td>
                    <Typeahead
                      id={`typeahead-event-type-${event.pk}`}
                      onChange={(selected) => onPropertyPublishApply(
                        event.pk,
                        'event_type',
                        selected[0]?.value || null
                      )}
                      onBlur={(e) => {
                        const inputValue = e.target.value;
                        const isValid = eventTypes.some((eventType) => eventType.label === inputValue);
                        if (!isValid) {
                          e.target.value = '';
                          onPropertyPublishApply(event.pk, 'event_type', null);
                        }
                      }}
                      options={eventTypes}
                      defaultSelected={
                        event.event_type ? eventTypes.filter((eventType) => eventType.value === event.event_type) : []
                      }
                      clearButton
                  />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Слаг</td>
                  <td>
                    <span><a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + event.pk + '/change/'} target='_blank' rel='noreferrer'>{event.slug}</a></span>
                  </td>
                </tr>
                {event.published_events_list.length === 0 &&
                <tr>
                  <td className='fw-bold'>URL Слаг</td>
                  <td className='d-flex align-items-center'>
                    <Form.Control
                      type='text'
                      defaultValue={event.sanitized_slug}
                      onChange={e => onPropertyPublishApply(event.pk, 'url_slug', e.target.value)}
                      className='me-2'
                      ref={(el) => slugInputRefs.current.set(event.pk, el)}
                    >
                    </Form.Control>
                    <Button onClick={() => transliterate(event.pk)} className='me-2'>Slug</Button>
                  </td>
                </tr>
                }
                {event.published_events_list.length !== 0 &&
                <tr>                
                  <td className='fw-bold'>URL Слаг</td> 
                  <td>
                    {event.published_events_list.map(published_event => (
                      <div key={published_event.pk}>
                        <span>{published_event.url_slug} </span>                      
                      </div>
                    ))}
                  </td>
                </tr>
                }
                {event.previous_version_event &&
                <tr>
                  <td className='fw-bold'>Предыдущая версия</td>
                  <td>
                    <a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + event.previous_version_event + '/change/'} target='_blank' rel='noreferrer'>#B {event.previous_version_event}</a>
                  </td>
                </tr>
                }
                {event.published_events_list.length !== 0 &&
                <tr>
                  <td className='fw-bold'>Опубликованные события</td>
                  <td>
                    {event.published_events_list.map(published_event => (
                      <div key={published_event.pk}>
                        <span><a href={REACT_APP_DJANGO_ADMIN_URL + 'events/event/' + published_event.pk + '/change/'} target='_blank' rel='noreferrer'>#B {published_event.pk}</a> </span>
                        <span><a href={REACT_APP_WEBSITE_URL + 'event/' + published_event.url_slug + '/'} target='_blank' rel='noreferrer'>#F {published_event.pk}</a> </span>
                      </div>
                    ))}
                  </td>
                </tr>
                }
                {event.is_instagram === false &&
                <>
                <tr>
                  <td className='fw-bold'>Дата (Отображение)</td>
                  <td>{event.date_display}</td>
                </tr>
                <tr>
                  <td className='fw-bold'>Стоимость (Отображение)</td>
                  <td>{event.price_display}</td>
                </tr>
                </>
                }
                <tr>
                  <td className='fw-bold'>Стоимость От</td>
                  <td>
                    <Form.Control
                      type='text'
                      defaultValue={event.price_from}
                      onChange={e => onPropertyPublishApply(event.pk, 'price_from', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Стоимость До</td>
                  <td>
                    <Form.Control
                      defaultValue={event.price_to}
                      onChange={e => onPropertyPublishApply(event.pk, 'price_to', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Стоимость Диапозон</td>
                  <td>
                    <Form.Check
                      defaultChecked={event.price_range}
                      onChange={e => onPropertyPublishApply(event.pk, 'price_range', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='fw-bold'>Стоимость Бесплатно</td>
                  <td>
                    <Form.Check
                      type='checkbox'
                      defaultChecked={event.price_free}
                      onChange={e => onPropertyPublishApply(event.pk, 'price_free', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{backgroundColor: "LightSlateGray", color: "white"}}
                    className='align-middle'
                    colSpan="2"
                  >
                    <span>Даты</span>
                    <span className="float-end" style={{'paddingLeft': '0px', 'paddingRight': '0px', 'cursor': 'pointer'}} onClick={() => onDateAdd(event.pk)}>
                      <Plus size={30} as="span" />
                    </span>
                  </td>
                </tr>
                {publishUpdates?.[event.pk]?.dates?.map((date, index) => (
                <Fragment key={index}>
                <tr>
                  <td>
                    <Form.Control
                      type='datetime-local'
                      value={date.start_date}
                      onChange={e => onPropertyDatePublishApply(event.pk, index, 'start_date', e.target.value)}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type='datetime-local'
                      value={date.end_date}
                      onChange={e => onPropertyDatePublishApply(event.pk, index, 'end_date', e.target.value)}
                    />
                  </td>
                </tr>                 
                <tr>
                  <td>
                    <Form.Check
                      checked={date.is_start_time_present}
                      onChange={e => onPropertyDatePublishApply(event.pk, index, 'is_start_time_present', e.target.checked)}
                      label='Start time present'
                    />
                  </td>
                  <td>
                    <Form.Check
                      checked={date.is_end_time_present}
                      onChange={e => onPropertyDatePublishApply(event.pk, index, 'is_end_time_present', e.target.checked)}
                      label='End time present'
                    />
                  </td>
                </tr>                 
                </Fragment>
                ))}
                {event.dates.map(date => (
                <tr key={date.pk}>
                  <td>{date.start_date_display}</td>
                  <td>{date.end_date_display}</td>
                </tr>                 
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        </Fragment>
      ))}
      <Modal
        show={confirmDialogShow}
        onHide={handleConfirmDialogClose}
        keyboard={false}
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Не все измененные элементы выделены. Продолжить?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleConfirmDialogClose}>Нет</Button>
          <Button variant="primary" onClick={handleConfirmDialogProceed}>Да</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={loading}
        keyboard={false}
        backdrop='static'
        centered
      >
        <Modal.Body className='text-center'>
          <Spinner animation='border' />
          <div>Loading...</div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EventsIncoming;
